/**
 * Beispiel-Widget für Testzwecke
 */
import React from 'react';

const HelloWorldWidget = ({ config, data, onDataChange, onConfigChange }) => {
  return (
    <div className="hello-world-widget">
      <h3>Hallo Welt Widget</h3>
      <p>Dies ist ein einfaches Beispiel-Widget für Testzwecke.</p>
      <p>Aktueller Widget-Titel: {config.title}</p>
      {data ? (
        <div>
          <h4>Daten:</h4>
          <pre>{JSON.stringify(data, null, 2)}</pre>
        </div>
      ) : (
        <p>Keine Daten geladen.</p>
      )}
    </div>
  );
};

export default HelloWorldWidget;
